export default function Home() {
  const siteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '嫩草视频',
    url: 'https://classwall.cn',
    description: '嫩草视频手机网页版无需下载APP，高清流畅观影，电影电视剧资源丰富，不卡顿即点即看。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://classwall.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '嫩草视频',
    url: 'https://classwall.cn',
    description: '在线视频内容聚合平台',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@nencaovideo.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(siteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <LatestSection />
        <StatsSection />
      </main>
    </>
  );
}

function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20dramatic%20cinematic%20scene%20with%20a%20modern%20home%20theater%20setup%2C%20large%20screen%20displaying%20vibrant%20colors%2C%20cozy%20warm%20lighting%2C%20comfortable%20seating%2C%20entertainment%20atmosphere%2C%20dark%20room%20with%20ambient%20glow%2C%20no%20people%2C%20cinematic%20composition%2C%20warm%20orange%20and%20golden%20tones&width=1800&height=900&seq=hero-bg-2025&orientation=landscape"
        alt="嫩草视频 - 高清流畅在线观影"
        title="嫩草视频 - 高清流畅在线观影平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-white mb-4 leading-tight">
          高清流畅，即点即看
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          无需下载APP，手机网页版直接观看，电影电视剧综艺动漫资源丰富，高清画质流畅不卡顿
        </p>

        <div className="w-full max-w-xl relative">
          <input
            type="text"
            placeholder="搜索你想看的电影、电视剧、综艺..."
            className="w-full pl-5 pr-14 py-3.5 rounded-full bg-white/95 text-foreground-800 placeholder-foreground-400 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400 shadow-lg"
          />
          <button className="absolute right-2 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-primary-500 text-white flex items-center justify-center hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap">
            <i className="ri-search-line text-lg"></i>
          </button>
        </div>

        <div className="flex items-center gap-4 mt-6">
          {['电影', '电视剧', '综艺', '动漫', '纪录片'].map((tag) => (
            <span
              key={tag}
              className="px-4 py-1.5 rounded-full bg-white/15 text-white text-sm backdrop-blur-sm whitespace-nowrap cursor-pointer hover:bg-white/25 transition-colors"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}

import { categories, videos } from '@/mocks/videos';
import { Link } from 'react-router-dom';
import VideoCard from '@/components/feature/VideoCard';

function CategorySection() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            视频分类
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            海量资源，满足你的各种观影需求
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-4 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

function FeaturedSection() {
  const hotVideos = videos.filter((v) => v.isHot).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm">大家都在看的精彩内容</p>
          </div>
          <Link
            to="/category/dianying"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotVideos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}

function LatestSection() {
  const newVideos = videos.filter((v) => v.isNew).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">
              最新上线
            </h2>
            <p className="text-foreground-500 text-sm">第一时间获取最新内容</p>
          </div>
          <Link
            to="/category/dianshiju"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {newVideos.map((video) => (
            <VideoCard key={video.id} {...video} />
          ))}
        </div>
      </div>
    </section>
  );
}

function StatsSection() {
  const stats = [
    { value: '50000+', label: '视频资源', icon: 'ri-film-line' },
    { value: '1000万+', label: '日活跃用户', icon: 'ri-user-line' },
    { value: '99.9%', label: '播放成功率', icon: 'ri-check-double-line' },
    { value: '24h', label: '持续更新', icon: 'ri-refresh-line' },
  ];

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-primary-500">
      <div className="max-w-[1200px] mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-white/20 flex items-center justify-center">
                <i className={`${stat.icon} text-white text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading text-white mb-1">
                {stat.value}
              </div>
              <div className="text-sm text-white/70">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}